import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SmoothScroll } from "@/lib/smooth-scroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";
import DisclaimerModal from "@/components/DisclaimerModal";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

export default function Layout({ children }) {
  return (
    <SmoothScroll>
      <ScrollToTop />
      <Navbar />
      <main className="relative">{children}</main>
      <Footer />
      <FloatingButtons />
      <DisclaimerModal />
    </SmoothScroll>
  );
}
